import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_PATH } from '../../../../constants/api-urls';
import { tap } from 'rxjs/operators';
import { EntitiesStore } from './entities.store';
import { ConfigQuery } from '../../stores/config/config.store';
import { BehaviorSubject } from 'rxjs';
import { LINK_IMAGE } from '../../../../constants/image';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class EntitiesService {
  locationAutomall = new BehaviorSubject<boolean>(false);

  brandColours = {
    default: {
      "--block-colour": "#ab1021",
      "--orange-gradient":
        "linear-gradient(90deg, #de2c40 0%, #de142a 49.48%, #ab1021 100%)",
    },
    automall: {
      "--block-colour": "#1fbecd",
      "--orange-gradient":
        "linear-gradient(90deg, #50c1cc 0%, #3ac2cf 49.48%, #21c2d1 100%)"
    },
    byd: {
      "--block-colour": "#003468",
      "--orange-gradient": "#003468"
    }
  };

  constructor(
    private http: HttpClient,
    private entitiesStore: EntitiesStore,
    private configQuery: ConfigQuery
  ) {}

  getEntities({
    includeTree = false,
    isPublic = false,
    noEntityContext = false,
    includeInactive = false,
  }) {
    let params = '';
    if (includeTree) {
      params = '?includes=tree';
    }
    if (includeInactive) {
      params += '&includes=inActive';
    }
    if (noEntityContext) {
      params += '&entityContext=-1';
    }
    const url = (isPublic ? API_PATH.entities.publics : API_PATH.entities.entities) + params;
    return this.http.get(url).pipe(
      tap((entities: any) => {
        this.entitiesStore.upsertMany(entities.list);
        this.entitiesStore.update({entitiesTree: entities});
      })
    )
  }

  private setFavicon(link) {
    const favIcon: HTMLLinkElement = document.querySelector('#favicon');
    favIcon.href = link;
  }

  setTheme(parentId?) {
    const companies = _.get(this.entitiesStore.getValue(), "entitiesTree.list");
    const automallCompany = companies && companies.length ? companies.find((company) => company["name"] == "Automall") : null;

    let theme = {}
    if (parentId === 'byd') {
      theme = this.brandColours['byd'];
      this.setFavicon(LINK_IMAGE.BYD_FAVICON);
    }
    else if (parentId && companies) {
      const isAutomallCompany = parentId == _.get(automallCompany, 'id');
      if (isAutomallCompany) {
        this.setFavicon(LINK_IMAGE.FAVICON_AUTOMALL);
        theme = this.brandColours['automall'];
      }
      else {
        this.setFavicon(LINK_IMAGE.FAVICON);
      }
    }

    this.locationAutomall.next(
      parentId && companies && parentId == _.get(automallCompany, 'id')
    );

    const container = document.querySelector("html");
    const colours = Object.assign({}, this.brandColours['default'], theme);
    Object.keys(colours).forEach((index) => {
      let colour = colours[index];
      container.style.setProperty(index, colour);
    });
  }
}